// extracted by mini-css-extract-plugin
export default {"HeaderFilterIcon":"style_HeaderFilterIcon__LvWC8"};